import ClientBasicInfo from "Components/Common/ClientBasicInfo";
import InvoicesBasicInfo from "Components/Common/InvoicesBasicInfo";
import InvoiceSummaryTotals from "./InvoiceSummaryTotals";
import InvoiceSummaryList from "./InvoiceSummaryList";
import { InvoiceDetailsPayload } from "types/invoice.api";
import InvoiceBasicInfo from "./InvoiceBasicInfo";
import { Card, CardBody, Col, Row } from "reactstrap";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "Components/Hooks/hooks";
import { createSelector } from "reselect";
import { selectInvoicesState } from "slices/invoices/reducer";
import { getInvoices } from "slices/thunks";

interface InvoiceSummaryProps {
  invoice: InvoiceDetailsPayload;
}

const InvoiceSummary: React.FC<InvoiceSummaryProps> = ({ invoice }) => {
  const invoiceSelector = createSelector([selectInvoicesState], (state) => ({
    invoiceItems: state.invoices,
    isLoading: state.status.fetch,
    error: state.errors.fetch,
    meta: state.pagination,
  }));
  const { invoiceItems } = useAppSelector(invoiceSelector);

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (invoice?.quote?.id) {
      dispatch(getInvoices({ quote_id: invoice.quote.id }));
    }
  }, [invoice]);

  return (
    <Row className="g-3 w-100">
      {/* LEFT SECTION */}
      <Col xl={9} lg={8} className="d-flex flex-column">
        <Card className="br-10 bg-white">
          <CardBody>
            <div className="bg-white br-10 flex-grow-1">
              <InvoiceSummaryList invoiceDetails={invoice} />
              <InvoiceSummaryTotals invoiceDetails={invoice} />
            </div>
          </CardBody>
        </Card>
      </Col>

      {/* RIGHT SIDEBAR */}
      <Col xl={3} lg={4}>
        <div className="d-flex flex-column gap-3">
          <InvoiceBasicInfo invoice={invoice} />
          <ClientBasicInfo client={invoice.client} />
          {invoiceItems.length > 0 && (
            <InvoicesBasicInfo inVoices={invoiceItems} />
          )}
        </div>
      </Col>
    </Row>
  );
};

export default InvoiceSummary;
